<template>
  <div class="categories">
    <div v-for='category in categories()'>
      <h3>
        <router-link :to='`/categories/${scrub(category)}`' class="category" active-class="active" exact>
        <a>{{ category }}</a>
        </router-link>
      </h3>

      <h4 v-for='subCategory in subCategories(category)' class="subcategories">
        <router-link :to='`/categories/${scrub(category)}/${scrub(subCategory)}`' class="subCategory" active-class="active" exact>
          {{ subCategory }}
        </router-link>
      </h4>
    </div>
  </div>
</template>

<script>
  import { scrubMixin } from '../mixins'
  export default {
    name: 'Categories',
    mixins: [scrubMixin()],
    methods: {
      categories () {
        return Object.keys(this.$store.getters.categories).sort()
      },
      subCategories (category) {
        return this.$store.getters.categories[category]
      }
    }
  }
</script>



// WEBPACK FOOTER //
// Categories.vue?2d3583c6